import { SEGMENTS_FAMILY_NAME } from "app/components/widget/widget-utilities/segments/constants";
import { DEFAULT_DURATION_FOR_SEGMENTS, getShouldHideSegments } from "./utils";

export const MonthlyVisits = {
    id: "SegmentsMonthlyVisits",
    properties: {
        order: "1",
        dropdownOrder: 1,
        hasWebSource: true,
        isHidden: getShouldHideSegments,
        component: "CustomSegments",
        viewPermissions: {
            trafficSources: ["Desktop", "Total"],
        },
        title: "dashboards.wizard.segments.monthlyVisits.title",
        group: "WebsiteAudienceOverview",
        family: SEGMENTS_FAMILY_NAME,
        dashboard: "true",
        width: 4,
        state: "digitalsuite_segments-analysis-traffic",
        apiController: "CustomSegments",
        availabilityComponent: "WsSegmentAnalysis",
        totalComponent: "TotalWebCustomSegmentsAnalysis",
        mobileWebComponent: "MobileWebCustomSegmentsAnalysis",
        periodOverPeriodSupport: true,
        noCompare: true,
        defaultDuration: DEFAULT_DURATION_FOR_SEGMENTS,
    },
    widgets: {
        single: {
            defaultType: "SegmentsMonthlyVisitsGraph",
            SegmentsMonthlyVisitsGraph: {
                properties: {
                    options: {
                        showLegend: true,
                    },
                    periodOverPeriodSupport: true,
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    type: "double?",
                    format: "minVisitsAbbr",
                    formatParameter: 3,
                    name: "CurrentInstalls",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
        compare: {
            defaultType: "SegmentsMonthlyVisitsGraph",
            SegmentsMonthlyVisitsGraph: {
                properties: {},
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    type: "double",
                    format: "percentagesign",
                    formatParameter: 0,
                    name: "Retention",
                    reversed: "False",
                    yAxisMax: 1,
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
    },
};
